import React, { FunctionComponent, useState } from 'react';
import styled from 'styled-components';

import { Modifier } from 'data/training';
import { TableContainer, TableBody, TableRow, TableCell, Table, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ModifierTitle, CompactAccordion } from './farm-profiles';

const NameCell = styled(TableCell)`
  display: flex;
  flex: 1;
  padding: 6px 16px;
  font-size: 13px;
  opacity: 0.6;
`;

type ModifiersTableProps = {
  modifiers: Modifier[];
  onPressRow: (modifier: Modifier) => void;
  title: string;
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
};

const ModifiersTable: FunctionComponent<ModifiersTableProps> = ({
  modifiers,
  onPressRow,
  title,
  expanded,
  onExpandedChange,
}) => {
  const [hoveredOverModifierId, setHoveredOverModifierId] = useState<string | undefined>(undefined);

  return (
    <CompactAccordion expanded={expanded} onChange={(_, isExpanded) => onExpandedChange(isExpanded)}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ fontSize: 16 }} />}
        aria-controls="panel1c-content"
        style={{ minHeight: 24, padding: '0 8px' }}
      >
        <ModifierTitle>{`${title} modifiers`}</ModifierTitle>
      </AccordionSummary>
      <TableContainer style={{ display: 'flex', flex: 1 }}>
        <Table size="small" style={{ display: 'flex', flex: 1 }}>
          <TableBody style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
            {modifiers.map((modifier) => (
              <TableRow
                key={modifier.id}
                onClick={() => onPressRow(modifier)}
                style={{
                  display: 'flex',
                  flex: 1,
                  ...(hoveredOverModifierId === modifier.id
                    ? { backgroundColor: '#e7f0f6', cursor: 'pointer' }
                    : {}),
                }}
                onMouseEnter={() => setHoveredOverModifierId(modifier.id)}
                onMouseLeave={() => setHoveredOverModifierId(undefined)}
              >
                <NameCell>{modifier.name}</NameCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </CompactAccordion>
  );
};

export default ModifiersTable;
